import { TYPE_PHONE, TYPE_RADIO } from "@components/Form"


const getCreateInputs = (updateSchema, sponsors = [], customInputs = []) => {
  const sponsorOptions = sponsors
    .map(({ id: value, name: label }) => ({ value, label }))
    .sort((a, b) => a.label.localeCompare(b.label))

  const hasSponsors = !!sponsorOptions

  const sponsorList = [
    ...sponsorOptions,
    ...[{
      value: "new",
      label: "Create a Sponsor"
    }]
  ]

  let inputs = [
    {
      type: TYPE_RADIO,
      name: "sponsorId",
      label: "Sponsor",
      options: sponsorList,
      required: true,
      placeholder: "Select or add a new sponsor",
      initialValue: !hasSponsors ? "new" : undefined,
      inputProps: {
        onChange: () => updateSchema()
      }
    },
  ]

  inputs = [
    ...inputs,
    ...customInputs,
    ...[
      {
        name: "email",
      },
      {
        name: "mobile",
        type: TYPE_PHONE,
      },
      {
        name: "givenName",
        label: "First Name",
      },
      {
        name: "familyName",
        label: "Last Name",
      },
    ]
  ]

  return inputs
}

export default getCreateInputs
